<template lang="pug">
#informacoes-gerais.row
    .col-12
        .dados-gerais
            item-informacoes(
                title='Monitoramentos ativos',
                iconClass='flow flow-pin',
                :value='value.quantidadeAreas'
            )

            item-informacoes(
                title='Área monitorada',
                iconClass='flow flow-satellite',
                :value='formatNumber(value.areaMonitoradaHa)',
                unidade='ha'
            )

            el-dropdown
                item-informacoes.alertas(
                    title='Alertas',
                    iconClass='flow flow-warning-sign',
                    :value='value.quantidadeAlertas + qtdAlertasSocioambientas',
                    unidade=''
                )
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item
                        ResumoAlertas

            item-informacoes(
                title='Não colhidas',
                iconClass='flow flow-leaf',
                :value='value.quantidadeAreasNaoColhidas',
                unidade='áreas'
            )

            item-informacoes(
                title='Em colheita',
                iconClass='flow flow-tractor',
                :value='value.quantidadeAreasEmColheita',
                unidade='áreas'
            )

            item-informacoes(
                title='Colhidas',
                iconClass='flow flow-verified',
                :value='value.quantidadeAreasColhidas',
                unidade='áreas'
            )
</template>

<script>
import ItemInformacoes from './ItemInformacoes';
import ContainerInformacoes from './ContainerInformacoes';
import ResumoAlertas from '@/components/alertas/resumo/ResumoAlertas';

import Formatters from '@/utils/formatters';

export default {
    name: 'DadosGeraisAreasMonitoradas',

    components: {
        ItemInformacoes,
        ResumoAlertas
    },

    extends: ContainerInformacoes,

    props: {
        value: {
            type: Object,
            required: true
        },

        qtdAlertasSocioambientas: {
            type: Number,
            required: false,
            default: 0
        }
    },

    methods: {
        formatNumber(value, precision = 2) {
            return Formatters.formatNumber(value, precision);
        }
    }
};
</script>

<style lang="scss">
.alertas:hover {
    cursor: pointer;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: transparent;
}
</style>
